/**
 * Tracks Apptimize SDK initialization so consumers can await it exactly once,
 * regardless of how many times waitForApptimizeToInitialize is called.
 */
class ApptimizeInitialization {
  private resolve!: () => void

  private readonly promise = new Promise<void>((resolve) => {
    this.resolve = resolve
  })

  wait() {
    return this.promise
  }

  complete() {
    this.resolve()
  }

  timeout() {
    this.resolve()
  }
}

const apptimizeInitialization = new ApptimizeInitialization()

export const waitForApptimizeToInitialize = () => apptimizeInitialization.wait()

export const completeApptimizeInitialization = () =>
  apptimizeInitialization.complete()

export const timeoutApptimizeInitialization = () =>
  apptimizeInitialization.timeout()
